<template>
  <!-- フィルム料（買掛金）登録/編集 -->
  <div class="egl-dialog-elm">
    <el-dialog
      :title="$locale('accountPayableManagement.filmFeeRegistration')"
      :visible="isShow"
      class="egl-dialog"
      ref="accountDialog"
      :modal="false"
      :modal-append-to-body="true"
      :show-close="true"
      :before-close="closeCallback"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        label-width="40px"
        :model="form"
        class="setForm"
        ref="payableForm"
        :rules="rules"
        :disabled="actionType === 'view'"
      >
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("global.basicInfo") }}
          </div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="
                $locale('accountPayableManagement.accountsPayableDetails')
              "
              prop="name"
            >
              <el-input
                :placeholder="
                  $locale(
                    'accountPayableManagement.accountsPayableDetails.placeholder'
                  )
                "
                v-model="form.name"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$locale('accountPayableManagement.requestDate')"
              prop="requestDeadDate"
            >
              <CommDatePicker
                v-model="form.requestDeadDate"
                :value.sync="form.requestDeadDate"
                width="100%"
                :showWeekly="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$locale('accountPayableManagement.paymentDueDate')"
              prop="payDate"
            >
              <CommDatePicker
                v-model="form.payDate"
                :value.sync="form.payDate"
                width="100%"
                :showWeekly="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $locale('accountPayableManagement.recordedAmount/invoiceAmount')
              "
              prop="needPayAmount"
            >
              <el-input
                :placeholder="
                  $locale(
                    'accountPayableManagement.recordedAmount/invoiceAmount.placeholder'
                  )
                "
                v-model="form.needPayAmount"
                @input="(value) => priceFormat_forPayable(value, form, 'needPayAmount')"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item :label="$locale('accountPayable.billMonth')" prop="billMonthDate">
              <el-date-picker v-model="form.billMonthDate" type="month" value-format="timestamp"></el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
        <hr class="dotted" />
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("accountPayableManagement.filmFeeDetails") }}
          </div>
          <el-tooltip
            :content="$locale('accountPayableManagement.filmFeeDetails')"
            placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$locale('accountPayableManagement.targetTheaters')"
              prop="cinemaName"
            >
              <el-select
                popper-class="account-payable"
                multiple
                v-model="form.targetSourceList.cinemaIdList"
              >
                <MultiSelect :list.sync="form.targetSourceList.cinemaIdList" :dataList="cinemaList" />
                <el-option
                  v-for="item in cinemaList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                  <div class="select-item">
                    <i
                      class="el-icon-check"
                      v-show="
                        form.targetSourceList.cinemaIdList.indexOf(item.id) >=
                        0
                      "
                    ></i
                    >{{ item.name }}
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $locale('accountPayableManagement.targetBusinessPartners')
              "
              prop="clientName"
            >
              <!-- <el-select
                popper-class="account-payable"
                multiple
                v-model="form.targetSourceList.clientIdList"
                :filterable="true"
              >
                <MultiSelect :list.sync="form.targetSourceList.clientIdList" :dataList="clientList" />
                <el-option
                  v-for="item in clientList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                  <div class="select-item">
                    <i
                      class="el-icon-check"
                      v-show="
                        form.targetSourceList.clientIdList.indexOf(item.id) >=
                        0
                      "
                    ></i
                    >{{ item.name }}
                  </div>
                </el-option>
              </el-select> -->
              <RemoteSelectV2
                ref="selectV2"
                type="client"
                :list="comClientList"
                v-model="form.targetSourceList.clientIdList"
                :formValue.sync="form.targetSourceList.clientIdList"
                @setList="arr => comClientList = arr"
                @selectAll="arr => form.targetSourceList.clientIdList = arr"
                :isSelectAllFunc="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="period">
          <p>{{ $locale("accountPayableManagement.filmChargeExtractionPeriod") }}</p>
          <div>
            <DatePickerGroup
              v-bind:start="form.targetSourceList.dateStartTime"
              v-bind:end="form.targetSourceList.dateEndTime"
              v-bind:max="Infinity"
              v-bind:isExp="true"
              @setFatherDate="getPeriod"
            />
            <el-button class="drawOut egl-btn-yellow" @click="extractionHandler">
              {{ $locale("accountPayableManagement.drawOut") }}
            </el-button>
          </div>
        </div>
        <el-table
          class="egl-table payTable"
          :data="tableData"
          show-summary
          :sum-text="
            $locale(
              'accountPayableManagement.theTotalAmountOfTheCompleteCollection'
            )
          "
          :summary-method="getSummaries"
          :row-class-name="setStatus"
          @select="tableSelect"
          @select-all="tableSelect"
          ref="payTable"
        >
          <el-table-column
            v-if="actionType !== 'view'"
            label=""
            width="80"
            type="selection"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.theaterName')"
            prop="cinemaName"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.customerName')"
            prop="clientName"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$locale('global.titleOfWork')"
            prop="filmName"
            sortable
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.targetPeriod')"
            prop="ticketing.dateInterval"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.income')"
            prop="ticketing.income"
            align="center"
            :formatter="formatPrice"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.mobilization')"
            prop="ticketing.actualNumber"
            align="center"
            :formatter="formatPrice"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.filmFee')"
            prop="ticketing.actualPayAmount"
            align="center"
            :formatter="formatPrice"
          ></el-table-column>
          <el-table-column
            :label="$locale('accountPayableManagement.calculateTheAmount')"
            prop="ticketing.payAmount"
            align="center"
          >
            <template slot-scope="scope">
              <p
                :class="
                  scope.row.ticketing.needPayAmount !==
                    scope.row.ticketing.actualPayAmount && 'red'
                "
              >
                {{ format(scope.row.ticketing.needPayAmount) }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div class="handle">
                <a
                  @click="toggleDetail(scope.row.ticketing.uuid, scope.$index)"
                  >{{ $locale("global.detail") }}</a
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="summary">
          <p>
            {{ $locale("accountPayableManagement.totalAmountOfSelectionItems")
            }}<span>{{ format(totalSelected) }}</span>
          </p>
          <p>
            {{
              $locale(
                "accountPayableManagement.differenceFromTheAmountStatedOnTheInvoice"
              )
            }}<span :class="diffPrice !== 0 && 'red'">{{
              format(diffPrice)
            }}</span>
          </p>
        </div>
      </el-form>
      <PaymentTable
        v-if="accountPayableArr.length > 0"
        v-bind:accountPayableArr="accountPayableArr"
        v-bind:actionType="actionType"
        @callFatherPayment="callFatherPayment"
      ></PaymentTable>
      <div slot="footer" class="dialog-footer" v-if="actionType !== 'view'">
        <el-button @click="closeCallback" class="egl-btn-white">{{ $locale("global.cancel") }}</el-button>
        <el-button
          @click="submit"
          :class="confirmBtnStyle ? 'egl-btn-gray' : 'egl-btn-yellow'"
          :disabled="confirmBtnStyle"
        >{{ $locale("global.confirm") }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$locale('accPayMDetail.filmFeeDetails')"
      :visible.sync="isDetailShow"
      class="egl-dialog detail"
      :modal="false"
      :before-close="toggleDetail"
      :modal-append-to-body="true"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        label-width="40px"
        :model="form"
        class="setForm"
      >
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("global.basicInfo") }}
          </div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$locale('accountPayableManagement.theaterName')"
            >
              <p>{{ detailForm.cinemaName }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$locale('accountPayableManagement.customerName')"
            >
              <p>{{ detailForm.clientName }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$locale('global.titleOfWork')">
              <p>{{ detailForm.filmName }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$locale('accountPayableManagement.targetPeriod')"
            >
              <p>{{ detailForm.duration }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$locale('accountPayableManagement.filmFee')">
              <p>{{ formatRounding(detailForm.needPayAmount) }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <hr class="dotted" />
        <div class="tipsBox">
          <div class="form-module-tit">
            {{ $locale("accountPayableManagement.filmFee") }}
          </div>
          <el-tooltip
            :content="$locale('accountPayableManagement.filmFee')"
            placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
        <el-table :data="tableData_detail" class="egl-table detailTable">
          <el-table-column
            type="index"
            :index="indexMethod"
            width="180"
            prop="0"
          ></el-table-column>
          <el-table-column
            :label="$locale('accPayMDetail.mainBusiness')"
            prop="normal"
          >
            <template slot-scope="scope">
              <el-input
                v-if="scope.$index === 4"
                v-model="detailInputPrice.normal"
                @input="(value) => priceFormat_forPayable(value, detailInputPrice, 'normal')"
                :disabled="isDisableInput || actionType === 'view'"
              />
              <p
                v-else-if="scope.$index === 5"
                :class="diffNormal !== 0 ? 'red' : ''"
              >
                {{ format(diffNormal) }}
              </p>
              <p v-else-if="scope.$index === 2">{{ format_per(scope.row.normal) }}</p>
              <p v-else>{{ detailFormatter(scope.row.normal, scope.$index) }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$locale('accPayMDetail.morningShow')"
            prop="morning"
          >
            <template slot-scope="scope">
              <el-input
                v-if="scope.$index === 4"
                v-model="detailInputPrice.morning"
                @input="(value) => priceFormat_forPayable(value, detailInputPrice, 'morning')"
                :disabled="isDisableInput || actionType === 'view'"
              />
              <p
                v-else-if="scope.$index === 5"
                :class="diffMorning !== 0 ? 'red' : ''"
              >
                {{ format(diffMorning) }}
              </p>
              <p v-else-if="scope.$index === 2">{{ format_per(scope.row.morning) }}</p>
              <p v-else>{{ detailFormatter(scope.row.morning, scope.$index) }}</p>
            </template></el-table-column
          >
          <el-table-column
            :label="$locale('accPayMDetail.lateShow')"
            prop="evening"
          >
            <template slot-scope="scope">
              <el-input
                v-if="scope.$index === 4"
                v-model="detailInputPrice.evening"
                @input="(value) => priceFormat_forPayable(value, detailInputPrice, 'evening')"
                :disabled="isDisableInput || actionType === 'view'"
              />
              <p
                v-else-if="scope.$index === 5"
                :class="diffEvening !== 0 ? 'red' : ''"
              >
                {{ format(diffEvening) }}
              </p>
              <p v-else-if="scope.$index === 2">{{ format_per(scope.row.evening) }}</p>
              <p v-else>{{ detailFormatter(scope.row.evening, scope.$index) }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$locale('accPayMDetail.allNight')"
            prop="overNight"
          >
            <template slot-scope="scope">
              <el-input
                v-if="scope.$index === 4"
                v-model="detailInputPrice.overNight"
                @input="(value) => priceFormat_forPayable(value, detailInputPrice, 'overNight')"
                :disabled="isDisableInput || actionType === 'view'"
              />
              <p
                v-else-if="scope.$index === 5"
                :class="diffOverNight !== 0 ? 'red' : ''"
              >
                {{ format(diffOverNight) }}
              </p>
              <p v-else-if="scope.$index === 2">{{ format_per(scope.row.overNight) }}</p>
              <p v-else>{{ detailFormatter(scope.row.overNight, scope.$index) }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :label="$locale('accPayMDetail.specialBusiness')"
            prop="special"
          >
            <template slot-scope="scope">
              <el-input
                v-if="scope.$index === 4"
                v-model="detailInputPrice.special"
                @input="(value) => priceFormat_forPayable(value, detailInputPrice, 'special')"
                :disabled="isDisableInput || actionType === 'view'"
              />
              <p
                v-else-if="scope.$index === 5"
                :class="diffSpecial !== 0 ? 'red' : ''"
              >
                {{ format(diffSpecial) }}
              </p>
              <p v-else-if="scope.$index === 2">{{ format_per(scope.row.special) }}</p>
              <p v-else>{{ detailFormatter(scope.row.special, scope.$index) }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$locale('accPayMDetail.total')" prop="total">
            <template slot-scope="scope">
              <p v-if="scope.$index === 4">{{ format(totalDetailPayAmount) }}</p>
              <p
                v-else-if="scope.$index === 5"
                :class="diffTotal !== 0 ? 'red' : ''"
              >
                {{ format(diffTotal) }}
              </p>
              <p v-else>{{ typeSummary(scope.$index) }}</p>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="actionType !== 'view'">
        <el-button @click="toggleDetail" class="egl-btn-white">{{ $locale("global.cancel") }}</el-button>
        <el-button @click="detailSave" class="egl-btn-yellow">{{ $locale("global.confirm") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import DatePickerGroup from "@/components/DatePickerGroup";
import MultiSelect from "@/components/common/MultiSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import {
  accPayCreate,
  extraction,
  update
} from "@/helpers/service/api/accPayManagement.js";
import { toThousands, rounding, priceFormat_forPayable } from "@/utils/common.js";
import PaymentTable from "./PaymentTable.vue";
import { getClientListService } from "@/helpers/service/api/common";
import { convertDateToJPTime } from "@/assets/js/accountPayable.js";
// const brandId = window.localStorage.getItem("brandId");
// let brandId;
export default {
  inject: [ "clientList" ],
  components: {
    CommDatePicker,
    DatePickerGroup,
    PaymentTable,
    MultiSelect,
    RemoteSelectV2,
    // InputSelect
  },
  created() {
    this.brandId = window.localStorage.getItem("brandId");
    this.form.requestDeadDate = this.today;
    this.form.payDate = this.today;
  },
  data() {
    return {
      brandId: "",
      isDetailShow: false,
      cinemaList: JSON.parse(window.localStorage.getItem("cinemaObj")),
      form: {
        name: "",
        needPayAmount: "",
        requestDeadDate: 0,
        payDate: 0,
        // billMonthDate: this.$moment().startOf("month").valueOf(),
        targetSourceList: {
          cinemaIdList: [],
          clientIdList: [],
          dateStartTime: 0,
          dateEndTime: 0,
          source: [],
        },
      },
      detailInputPrice: {
        normal: "",
        morning: "",
        evening: "",
        overNight: "",
        special: "",
        total: 0,
      },
      detailDiffPrice: {
        normal: "0",
        morning: "0",
        evening: "0",
        overNight: "0",
        special: "0",
        total: "0",
      },
      detailForm: {
        cinemaName: "",
        clientName: "",
        filmName: "",
        duration: "",
        needPayAmount: "",
      },
      detailIndexName: [
        this.$locale("accountPayableManagement.income"),
        this.$locale("accountPayableManagement.mobilization"),
        this.$locale("accPayMDetail.filmRate"),
        this.$locale("accountPayableManagement.filmFee"),
        this.$locale("accountPayableManagement.calculateTheAmount"),
        this.$locale("accPayMDetail.difference"),
      ],
      tableData: [],
      tableData_detail: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$locale("accPayM.nameMsg"),
            trigger: "blur",
          },
        ],
        needPayAmount: [
          {
            required: true,
            message: this.$locale("accPayM.amount"),
            trigger: "blur",
          },
        ],
        // cinemaName: [
        //   { required: true, message: this.$locale("accPayM.theater"), trigger: "blur" },
        // ],
        // clientName: [
        //   { required: true, message: this.$locale("accPayM.client"), trigger: "blur" },
        // ]
      },
      selectedTableData: [],
      // isShowSelect: false,
      curUid: 0,
      isDisableInput: false,
      priceFormat_forPayable,
      comClientList: [],
    };
  },
  computed: {
    injectClientList() {
      return this.clientList();
    },
    today() {
      return this.$moment().startOf("day").valueOf();
    },
    totalIncome() {
      let total = 0;
      this.tableData.forEach(item => {
        total += item.ticketing.income;
      });
      return total;
    },
    totalActualNumber() {
      let total = 0;
      this.tableData.forEach(item => {
        total += item.ticketing.actualNumber;
      });
      return total;
    },
    totalActualPayAmount() {
      let total = 0;
      this.tableData.forEach(item => {
        total += item.ticketing.actualPayAmount;
      });
      return total;
    },
    totalNeedPayAmout() {
      let total = 0;
      this.tableData.forEach(item => {
        total += rounding(item.ticketing.needPayAmount, this.roundType);
      });
      return total;
    },
    totalSelected() {
      let total = 0;
      this.selectedTableData.forEach(item => {
        total += item.ticketing.needPayAmount;
      });
      return total;
    },
    diffPrice() {
      return this.totalSelected - this.strToNumber(this.form.needPayAmount);
    },
    totalDetailPayAmount() {
      if (this.isDisableInput) {
        // return this.totalDetailActualPayAmount;
        return this.strToNumber(this.typeSummary(3));
      }
      // return rounding(this.strToNumber(this.detailInputPrice.evening) +
      //   this.strToNumber(this.detailInputPrice.morning) +
      //   this.strToNumber(this.detailInputPrice.normal) +
      //   this.strToNumber(this.detailInputPrice.overNight) +
      //   this.strToNumber(this.detailInputPrice.special), this.roundType);
      const evening = this.strToNumber(this.detailInputPrice.evening);
      const morning = this.strToNumber(this.detailInputPrice.morning);
      const normal = this.strToNumber(this.detailInputPrice.normal);
      const overNight = this.strToNumber(this.detailInputPrice.overNight);
      const special = this.strToNumber(this.detailInputPrice.special);
      const total = rounding(evening, this.roundType) + rounding(morning, this.roundType) +
      rounding(normal, this.roundType) + rounding(overNight, this.roundType) + rounding(special, this.roundType);
      return isNaN(total) ? 0 : total;
    },
    diffNormal() {
      if (this.tableData_detail.length > 0) {
        let num = this.tableData_detail[3].normal === null || isNaN(this.tableData_detail[3].normal) ? 0 : this.tableData_detail[3].normal;
        return rounding(isNaN(this.strToNumber(this.detailInputPrice.normal)) ? 0 : this.strToNumber(this.detailInputPrice.normal) -
          num, this.roundType);
      }
      return 0;
    },
    diffMorning() {
      if (this.tableData_detail.length > 0) {
        let num = this.tableData_detail[3].morning === null ? 0 : this.tableData_detail[3].morning;
        return rounding(isNaN(this.strToNumber(this.detailInputPrice.morning)) ? 0 : this.strToNumber(this.detailInputPrice.morning) -
          num, this.roundType);
      }
      return 0;
    },
    diffOverNight() {
      if (this.tableData_detail.length > 0) {
        let num = this.tableData_detail[3].overNight === null ? 0 : this.tableData_detail[3].overNight;
        return rounding(isNaN(this.strToNumber(this.detailInputPrice.overNight)) ? 0 : this.strToNumber(this.detailInputPrice.overNight) -
          num, this.roundType);
      }
      return 0;
    },
    diffEvening() {
      if (this.tableData_detail.length > 0) {
        let num = this.tableData_detail[3].evening === null ? 0 : this.tableData_detail[3].evening;
        return rounding(isNaN(this.strToNumber(this.detailInputPrice.evening)) ? 0 : this.strToNumber(this.detailInputPrice.evening) -
          num, this.roundType);
      }
      return 0;
    },
    diffSpecial() {
      if (this.tableData_detail.length > 0) {
        let num = this.tableData_detail[3].special === null ? 0 : this.tableData_detail[3].special;
        return rounding(isNaN(this.strToNumber(this.detailInputPrice.special)) ? 0 : this.strToNumber(this.detailInputPrice.special) -
          num, this.roundType);
      }
      return 0;
    },
    diffTotal() {
      return rounding(this.strToNumber(this.totalDetailPayAmount) - this.strToNumber(this.typeSummary(3)), this.roundType);
    },
    confirmBtnStyle() {
      return this.diffPrice !== 0 || this.tableData.length === 0 || this.selectedTableData.length === 0;
    },
  },
  watch: {
    actionType(val) {
      this.tableData = [];
      if (val === "" || val === "registration") {
        this.form = {
          name: "",
          needPayAmount: "",
          requestDeadDate: Date.now().valueOf(),
          payDate: Date.now().valueOf(),
          // billMonthDate: this.$moment().startOf("month").valueOf(),
          targetSourceList: {
            cinemaIdList: [],
            clientIdList: [],
            dateStartTime: 0,
            dateEndTime: 0,
            source: [],
          },
        };
        return;
      }
      this.form = {
        name: this.forMsg.name,
        needPayAmount: this.forMsg.needPayAmount,
        requestDeadDate: this.forMsg.requestDeadDate,
        payDate: this.forMsg.payDate,
        targetSourceList: {
          cinemaIdList: this.forMsg.targetSourceList.cinemaIdList === null ? [] : this.forMsg.targetSourceList.cinemaIdList,
          clientIdList: this.forMsg.targetSourceList.clientIdList === null ?  [] : this.forMsg.targetSourceList.clientIdList,
          dateEndTime: this.forMsg.targetSourceList.dateEndTime,
          dateStartTime: this.forMsg.targetSourceList.dateStartTime,
          source: this.forMsg.targetSourceList.source,
        }
      };
      if (this.forMsg.type === "TICKETING") {
        this.tableData = this.forMsg.targetSourceList.source;
        this.tableData.forEach(item => {
          let { evening, morning, normal, overNight, special } = item.ticketing.amountDetail;
          item.ticketing.income = evening.income + morning.income + normal.income + overNight.income + special.income;
        });
        this.$nextTick(() => {
          this.$refs["payTable"].toggleAllSelection();
          this.setSummaryStyle();
        });
      }
    },
    "form.targetSourceList.cinemaIdList"(arr, oldArr) {
      if (this.isShow && oldArr.length != 0 && oldArr.length > arr.length) {
        this.selectedTableData = [];
        this.tableData = [];
      }
    },
    "form.targetSourceList.clientIdList"(arr, oldArr) {
      if (this.isShow && oldArr.length != 0 && oldArr.length > arr.length) {
        this.selectedTableData = [];
        this.tableData = [];
      }
    },
    isShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs["selectV2"].page = 1;
        });
        if (this.form.targetSourceList.clientIdList.length > 0) {
          getClientListService({
            ...this.form.targetSourceList.clientIdList ? { ids: this.form.targetSourceList.clientIdList } : {},
            page: 0,
            pageSize: this.form.targetSourceList.clientIdList.length > 0 ? 9999 : 20,
            field: ["id", "name"]
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.comClientList = this.$_.uniqBy(res.data.data.concat(this.injectClientList), "id");
              // this.$refs["selectV2"].page = 0;
              // if (this.form.targetSourceList.clientIdList.length === 0) this.$refs["selectV2"].page++;
            }
          });
        } else {
          this.comClientList = this.injectClientList;
        }
      }
    }
  },
  methods: {
    getTotal(idx) {
      switch (idx) {
      case 0:
        return toThousands(this.totalDetailIncome);
      case 1:
        return toThousands(this.totalDetailActualNumber);
      case 2:
        return "-";
      case 3:
        return toThousands(this.totalDetailActualPayAmount);
      default:
        break;
      }
    },
    tableSelect(value) {
      this.selectedTableData = value;
    },
    strToNumber(str) {
      if (str === "") {
        return 0;
      } else if(typeof str === "number" || str === null) {
        
        return str;
      } else if (str.indexOf(".") > -1) {
        return parseFloat(str.replace(/,/g, ""));
      }
      return parseFloat(str.replace(/,/g, ""));
    },
    setStatus({ row }) {
      // console.log(row);
      if (row.ticketing.warning) {
        return "warning";
      }
    },
    toggleDetail(id, idx) {
      if (id !== undefined && idx !== undefined) {
        this.curUid = id;
        this.tableData.forEach(item => {
          if (id === item.ticketing.uuid) {
            this.isDisableInput = item.ticketing.stable;
            this.detailForm = {
              cinemaName: item.cinemaName,
              clientName: item.clientName,
              filmName: item.filmName,
              duration: item.ticketing.dateInterval,
              needPayAmount: toThousands(item.ticketing.needPayAmount),
            };
            const amoutDetail = item.ticketing.amountDetail;
            let data = [
              // 興行収入
              {
                evening: amoutDetail.evening.income,
                morning: amoutDetail.morning.income,
                normal: amoutDetail.normal.income,
                overNight: amoutDetail.overNight.income,
                special: amoutDetail.special.income,
              },
              // 動員
              {
                evening: amoutDetail.evening.actualNumber,
                morning: amoutDetail.morning.actualNumber,
                normal: amoutDetail.normal.actualNumber,
                overNight: amoutDetail.overNight.actualNumber,
                special: amoutDetail.special.actualNumber,
              },
              // フィルム料歩率
              {
                evening: amoutDetail.evening.rate,
                morning: amoutDetail.morning.rate,
                normal: amoutDetail.normal.rate,
                overNight: amoutDetail.overNight.rate,
                special: amoutDetail.special.rate,
              },
              // フィルム料
              {
                evening: amoutDetail.evening.needPayAmount,
                morning: amoutDetail.morning.needPayAmount,
                normal: amoutDetail.normal.needPayAmount,
                overNight: amoutDetail.overNight.needPayAmount,
                special: amoutDetail.special.needPayAmount,
              },
              {},
              {},
            ];
            this.tableData_detail = data;
            // this.detailInputPrice = {
            //   evening: this.isDisableInput
            //     ? "-"
            //     : (this.tableData_detail[3].evening === "-" ? 0 : toThousands(this.tableData_detail[3].evening)),
            //   morning: this.isDisableInput
            //     ? "-"
            //     : (this.tableData_detail[3].morning === "-" ? 0 : toThousands(this.tableData_detail[3].morning)),
            //   normal: this.isDisableInput
            //     ? "-"
            //     : (this.tableData_detail[3].normal === "-" ? 0 : toThousands(this.tableData_detail[3].normal)),
            //   overNight: this.isDisableInput
            //     ? "-"
            //     : (this.tableData_detail[3].overNight === "-" ? 0 : toThousands(this.tableData_detail[3].overNight)),
            //   special: this.isDisableInput
            //     ? "-"
            //     : (this.tableData_detail[3].special === "-" ? 0 : toThousands(this.tableData_detail[3].special)),
            // };
            const [, , rate, obj] = this.tableData_detail;
            const { evening, morning, normal, overNight, special } = obj;
            this.detailInputPrice = {
              evening: this.isDisableInput ? "-" : (evening === "-" || rate.evening === null ? 0 : amoutDetail.evening.payAmount),
              morning: this.isDisableInput ? "-" : (morning === "-" || rate.morning === null ? 0 : amoutDetail.morning.payAmount),
              normal: this.isDisableInput ? "-" : (normal === "-" || rate.normal === null ? 0 : amoutDetail.normal.payAmount),
              overNight: this.isDisableInput ? "-" : (overNight === "-" || rate.overNight ? 0 : amoutDetail.overNight.payAmount),
              special: this.isDisableInput ? "-" : (special === "-" || rate.special ? 0 : amoutDetail.special.payAmount),
            };
            return;
          }
        });
      }
      this.isDetailShow = !this.isDetailShow;
      this.$nextTick(() => {
        let current = this.$el
          .querySelector(".detailTable")
          .querySelector(".el-table__header-wrapper");
        let cell = current.querySelectorAll("thead tr th");
        cell[0].innerText = "";
      });
    },
    getReqDate(num) {
      this.form.requestDeadDate = num;
    },
    getPayDate(num) {
      this.form.payDate = num;
    },
    getPeriod(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.form.targetSourceList.dateStartTime = startDate;
      }
      if (endDate) {
        this.form.targetSourceList.dateEndTime = endDate;
      }
    },
    selectHandler(method, form, listName) {
      form.targetSourceList[listName] = [];
      if (method === "select") {
        if (form.targetSourceList[listName].length < 5) {
          if (listName === "cinemaIdList") {
            this.cinemaList.forEach(item => {
              form.targetSourceList[listName].push(item.id);
            });
          } else {
            this.clientList.forEach(item => {
              form.targetSourceList[listName].push(item.id);
            });
          }
        }
      }
    },
    closeCallback() {
      this.beforeCloseHandler();
      if (this.actionType === "edit") {
        this.$emit("refreshTable", undefined, false);
      }
    },
    submitCallback() {
      this.beforeCloseHandler();
      if (this.actionType === "edit") {
        this.$emit("refreshTable", this.$locale("global.updateSuccessfully"));
      } else {
        this.$emit("refreshTable");
      }
    },
    submit() {
      this.$refs.payableForm.validate(valid => {
        if (valid) {
          let data = {
            ...this.actionType === "edit" ? { id: this.forMsg.id } : {},
            brandId: this.brandId,
            needPayAmount: this.strToNumber(this.form.needPayAmount),
            name: this.form.name,
            payDate: this.form.payDate,
            requestDeadDate: this.form.requestDeadDate,
            // billMonthDate: this.form.billMonthDate,
            targetSourceList: {
              cinemaIdList: this.form.targetSourceList.cinemaIdList,
              clientIdList: this.form.targetSourceList.clientIdList,
              dateStartTime: this.form.targetSourceList.dateStartTime,
              dateEndTime: this.form.targetSourceList.dateEndTime,
              source: this.selectedTableData,
            },
            type: "TICKETING"
          };
          if (this.actionType === "edit") {
            update(data).then(() => this.submitCallback());
          } else {
            accPayCreate(data).then(() => this.submitCallback());
          }
        }
      });
    },
    extractionHandler() {
      const that = this;
      if (
        this.form.targetSourceList.cinemaIdList.length === 0 ||
        this.form.targetSourceList.clientIdList.length === 0
      ) {
        let errText = this.form.targetSourceList.cinemaIdList.length === 0 ? this.$locale("accPayM.errText1") : this.$locale("accPayM.errText2");
        this.$alert(errText);
      } else {
        this.selectedTableData = [];
        this.tableData = [];
        this.form.targetSourceList.dateEndTime =
          this.form.targetSourceList.dateEndTime === 0
            ? this.today
            : this.form.targetSourceList.dateEndTime;
        this.form.targetSourceList.dateStartTime =
          this.form.targetSourceList.dateStartTime === 0
            ? this.today
            : this.form.targetSourceList.dateStartTime;
        extraction({
          brandId: this.brandId,
          cinemaIds: this.form.targetSourceList.cinemaIdList,
          clientIds: this.form.targetSourceList.clientIdList,
          dateEndTime: convertDateToJPTime(this.form.targetSourceList.dateEndTime).valueOf(),
          dateStartTime: convertDateToJPTime(this.form.targetSourceList.dateStartTime).valueOf(),
          type: "TICKETING",
        }).then(res => {
          if (res.data.length > 0) {
            let { data } = res;
            data.forEach(item => {
              let clinentSetting = "";
              const { amountDetail } = item.ticketing;
              const itemClientId = item.ticketing.clientId;
              const keyNames = ["evening", "morning", "normal", "overNight", "special"];

              for (let i = 0; i < that.clientList.length; i++) {
                if (that.clientList[i].id == itemClientId) {
                  clinentSetting = that.clientList[i].round;
                  break;
                }
              }

              keyNames.map(keyName => {
                for (let numKey in amountDetail[keyName]) {
                  if (typeof(amountDetail[keyName][numKey]) == "number") {
                    switch (clinentSetting) {
                      case "ROUND":
                        amountDetail[keyName][numKey] = Math.round(amountDetail[keyName][numKey]);
                        break;
                      case "ROUND_UP":
                        amountDetail[keyName][numKey] = Math.ceil(amountDetail[keyName][numKey]);
                        break;
                      case "ROUND_DOWN":
                        amountDetail[keyName][numKey] = Math.floor(amountDetail[keyName][numKey]);
                        break;
                      default:
                        break;
                    }
                  }
                }
              });

              item.ticketing.income =
                amountDetail.evening.income +
                amountDetail.morning.income +
                amountDetail.normal.income +
                amountDetail.overNight.income +
                amountDetail.special.income;

              switch (clinentSetting) {
                case "ROUND":
                  item.ticketing.actualPayAmount = Math.round(item.ticketing.actualPayAmount);
                  item.ticketing.needPayAmount = Math.round(item.ticketing.needPayAmount);
                  break;
                case "ROUND_UP":
                  item.ticketing.actualPayAmount = Math.ceil(item.ticketing.actualPayAmount);
                  item.ticketing.needPayAmount = Math.ceil(item.ticketing.needPayAmount);
                  break;
                case "ROUND_DOWN":
                  item.ticketing.actualPayAmount = Math.floor(item.ticketing.actualPayAmount);
                  item.ticketing.needPayAmount = Math.floor(item.ticketing.needPayAmount);
                  break;
                default:
                  break;
              }
            });
            this.tableData = data;
          }
          if (res.message) {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
          this.setSummaryStyle();
        });
      }
    },
    setSummaryStyle() {
      let current = this.$el
        .querySelector(".payTable")
        .querySelector(".el-table__footer-wrapper");
      let cell = current.querySelectorAll("tbody tr td");
      cell[this.actionType === "view" ? 3 : 4].innerText = this.$locale("accountPayableManagement.theTotalAmountOfTheCompleteCollection");
      cell[0].innerText = "";
    },
    beforeCloseHandler() {
      this.form.name = "";
      this.form.needPayAmount = "";
      this.form.requestDeadDate = this.today;
      this.form.payDate = this.today;
      this.form.targetSourceList.cinemaIdList = [];
      this.form.targetSourceList.clientIdList = [];
      this.form.targetSourceList.source = [];
      this.form.targetSourceList = {
        cinemaIdList: [],
        clientIdList: [],
        dateStartTime: 0,
        dateEndTime: 0,
        source: [],
      };
      this.tableData = [];
      this.selectedTableData = [];
      this.$emit("closeFn");
    },
    indexMethod(index) {
      return this.detailIndexName[index];
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        switch (index) {
        case this.actionType === "view" ? 4 : 5:
          sums[index] = toThousands(rounding(this.totalIncome, this.roundType));
          break;
        case this.actionType === "view" ? 5 : 6:
          sums[index] = toThousands(this.totalActualNumber);
          break;
        case this.actionType === "view" ? 6 : 7:
          sums[index] = toThousands(rounding(this.totalActualPayAmount, this.roundType));
          break;
        case this.actionType === "view" ? 7 : 8:
          sums[index] = toThousands(rounding(this.totalNeedPayAmout, this.roundType));
          break;
        default:
          break;
        }
      });
      return sums;
    },
    formatInput(value, key) {
      if (value) {
        this.detailInputPrice[key] = toThousands(this.strToNumber(value));
      }
    },
    detailInput_fn(val) {
      // console.log(val);
    },
    detailSave() {
      let data = JSON.parse(JSON.stringify(this.tableData));
      data.forEach(item => {
        if (item.ticketing.uuid === this.curUid) {
          item.ticketing.amountDetail.evening.payAmount = this.strToNumber(this.detailInputPrice.evening);
          item.ticketing.amountDetail.morning.payAmount = this.strToNumber(this.detailInputPrice.morning);
          item.ticketing.amountDetail.normal.payAmount = this.strToNumber(this.detailInputPrice.normal);
          item.ticketing.amountDetail.overNight.payAmount = this.strToNumber(this.detailInputPrice.overNight);
          item.ticketing.amountDetail.special.payAmount = this.strToNumber(this.detailInputPrice.special);
          item.ticketing.needPayAmount = this.totalDetailPayAmount;
        }
      });
      this.tableData = data;
      this.toggleDetail();
    },
    formatPrice(row, column) {
      if (column.property === "ticketing.income") {
        return toThousands(rounding(row.ticketing.income, this.roundType, 2));
      }
      if (column.property === "ticketing.actualNumber") {
        return toThousands(row.ticketing.actualNumber);
      }
      if (column.property === "ticketing.actualPayAmount") {
        return toThousands(rounding(row.ticketing.actualPayAmount, this.roundType, 2));
      }
    },
    format(num) {
      return isNaN(num) ? num : toThousands(rounding(num, this.roundType, 2));
    },
    format_per(num) {
      if (num === null) {
        return "-";
      }
      return rounding(num * 100, this.roundType) / 100 + "%";
    },
    detailFormatter(value, idx) {
      return value === null ? "-" : idx === 1 ? toThousands(value) : toThousands(rounding(value, this.roundType, 2));
    },
    typeSummary(index) {
      if (this.tableData_detail.length > 0) {
        let {
          evening,
          morning,
          normal,
          overNight,
          special
        } = this.tableData_detail[index];
        if (index === 2) {
          return "-";
        }
        evening = evening === null ? 0 : evening;
        morning = morning === null ? 0 : morning;
        normal = normal === null ? 0 : normal;
        overNight = overNight === null ? 0 : overNight;
        special = special === null ? 0 : special;
        // return toThousands(rounding(evening + morning + normal + overNight + special, this.roundType));
        return toThousands(evening + morning + normal + overNight + special);
      }
      return 0;
    },
    // export() {
    //   exportCSV({
    //     brandId
    //   }).then(res => {
    //     console.log(res);
    //   });
    // },
    callFatherPayment(index, act) {
      this.$emit("showPaymentRegistration", -1, act, index);
    },
    formatRounding(val) {
      return toThousands(rounding(this.strToNumber(val), this.roundType, 2));
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    // clientList: {
    //   type: Array,
    // },
    closeFn: {
      type: Function,
    },
    refreshTable: {
      type: Function,
    },
    actionType: {
      type: String,
      default: "view",
    },
    forMsg: {
      type: Object,
    },
    accountPayableArr: {
      type: Array,
      default: () => [],
    },
    roundType: {
      type: String,
      default: "",
    }
  },
};
</script>
